import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { FormEventHandler } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Bouton from "../../../components/Button/Bouton";
import Divider from "../../../components/Divider";
import FormContainer from "../../../components/FormContainer";
import InputField from "../../../components/input/InputField";
import InputPassword from "../../../components/input/InputPassword";
import Select, { DropdownItem } from "../../../components/select/Select";
import TransferList from "../../../components/TransferList";
import { isEmail, isMotDePasse } from "../../../helpers/validators";
import {
  AdministrateurBien,
  AdministrateurBienDetail,
  ApplicationImmobilierDetail,
  FonctionPoste,
  Utilisateur,
  UtilisateurDetailAdbProfilSites,
} from "../../../services/Api/swagger/api.js";
import ErreursConstante from "../../../_constantes/erreursConstantes.json";
import {
  construireListFonctionsOptions,
  construireListRegroupements,
} from "../helpers";
import AjouterSitesAdb from "./AjouterSitesAdb";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { isEmpty } from "lodash";

export interface UtilisateurFormErrors {
  nom?: string;
  prenom?: string;
  mail?: string;
  listAdb?: string;
  adbs?: any;
  motDePasse?: string;
  confirmationMotDePasse?: string;
}

export interface UtilisateurFormData {
  nom: string;
  prenom: string;
  mail: string;
  identifiant: string;
  fonction: string;
  listAdb: DropdownItem[];
  adbs?: UtilisateurDetailAdbProfilSites[];
  motDePasse?: string;
  confirmationMotDePasse: string;
}
interface CustomProps {
  formValues: UtilisateurFormData;
  formErrors?: UtilisateurFormErrors;
  classes?: any;
  fonctionsPostes?: FonctionPoste[];
  adbDetailProfils?: ApplicationImmobilierDetail[];
  selectedAdb?: AdministrateurBienDetail;
  adbRegroupementList?: AdministrateurBien[];
  handlePrecedent(): void;
  utilisateurBESSE?: boolean;
  utilisateurConnecte: Utilisateur;
  // pushArray(form: string, field: string, index: number, value: any): void;
  // removeArray(form: string, field: string, index: number): void;
  isFetching: boolean;
  disabled?: boolean;
  isModify?: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  push: (...args: any[]) => any;
  pop: (...args: any[]) => any;
}

function UtilisateurAdbForm({
  fonctionsPostes,
  adbRegroupementList,
  isFetching,
  disabled,
  isModify,
  formValues,
  onSubmit,
  handlePrecedent,
  push,
  pop,
  utilisateurConnecte,
  selectedAdb,
}: CustomProps) {
  const handleChangeAdbRegroupements = (value: { value: string }) => {
    const id = value.value;

    // const index = formValues && formValues.adbs ? formValues.adbs.length : 0;
    push("adbs", {
      refAdb: id,
    });
    // getAdbDetail(Number(id));
  };

  const handleRemoveAdbRegroupements = (value: DropdownItem) => {
    // getAdbDetail(Number(value.value));
    // const index =
    //   formValues.adbs &&
    //   formValues.adbs.findIndex((adb) => adb.refAdb === Number(value.value));

    // if (index || index === 0) {
    pop("adbs");
    // }
  };

  const optionsFonctionsPostes =
    (fonctionsPostes && construireListFonctionsOptions(fonctionsPostes)) || [];

  const optionsRegroupements =
    (adbRegroupementList && construireListRegroupements(adbRegroupementList)) ||
    [];

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(e);
      }}
      noValidate
    >
      <FormContainer>
        <Grid container spacing={1}>
          <Grid item>
            <Field
              name="nom"
              component={InputField}
              label="Nom"
              required
              disabled={disabled}
            />
          </Grid>
          <Grid item>
            <Field
              name="prenom"
              component={InputField}
              label="Prénom"
              required
              disabled={disabled}
            />
          </Grid>
          <Grid item>
            <Field
              name="mail"
              component={InputField}
              label="E-mail"
              required
              size={50}
              disabled={disabled}
            />
          </Grid>
        </Grid>
        {!isModify && (
          <Grid container spacing={1}>
            <Grid item>
              <Field
                label="Mot de passe"
                name="motDePasse"
                component={InputPassword}
                type="password"
                required
              />
            </Grid>
            <Grid item>
              <Field
                label="Confirmation de votre mot de passe"
                name="confirmationMotDePasse"
                component={InputPassword}
                type="password"
                size={25}
                required
              />
            </Grid>
          </Grid>
        )}
        <Grid container spacing={0}>
          <Typography style={{ marginTop: "-8px" }} variant="caption">
            Le mot de passe doit avoir au moins 8 caractères, 1 majuscule, 1
            minuscule et 1 chiffre.
          </Typography>
        </Grid>
        <Grid container spacing={1}>
          <Grid item>
            <Field
              name="fonction"
              component={Select}
              label="Fonction"
              options={optionsFonctionsPostes}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </FormContainer>
      <Grid container>
        <h3>Regroupements</h3>
      </Grid>
      <FormContainer>
        <Grid container spacing={1}>
          <Grid item>
            <Field
              name="listAdb"
              component={TransferList}
              label="Administrateur de biens"
              required
              options={optionsRegroupements}
              onAdd={handleChangeAdbRegroupements}
              onRemove={handleRemoveAdbRegroupements}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </FormContainer>
      {/* <FieldArray name="adbs" component={renderAdbs} /> */}
      <FieldArray name="adbs">
        {({ fields }) =>
          fields &&
          fields.map((item, index) => {
            return (
              <>
                {index > 0 && <Divider />}

                <AjouterSitesAdb
                  key={index}
                  index={index}
                  adb={item}
                  selectedAdb={selectedAdb}
                  fields={fields}
                  valueAdb={formValues.adbs && formValues.adbs[index]}
                  utilisateurConnecteAdb={
                    utilisateurConnecte.detailAdbProfilSites
                  }
                  disabled={disabled}
                />
              </>
            );
          })
        }
      </FieldArray>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Bouton
            label="Annuler"
            variant="contained"
            color="inherit"
            size="medium"
            onClick={handlePrecedent}
          />
        </Grid>
        <Grid item>
          {!disabled && (
            <Bouton
              fetching={isFetching}
              label="Enregistrer"
              variant="contained"
              color="primary"
              size="medium"
              type="submit"
            />
          )}
        </Grid>
      </Grid>
    </form>
  );
}

/**
 * Méthode de validation du formulaire
 * @param values
 */
export const validateForm = (
  values: UtilisateurFormData,
  isModify?: boolean,
): UtilisateurFormErrors => {
  const errors: UtilisateurFormErrors = {} as UtilisateurFormErrors;

  if (values && !isEmpty(values)) {
    if (!values.nom) {
      errors.nom = ErreursConstante.formulaire.generale.champObligatoire;
    }
    if (!values.prenom) {
      errors.prenom = ErreursConstante.formulaire.generale.champObligatoire;
    }
    if (!values.mail) {
      errors.mail = ErreursConstante.formulaire.generale.champObligatoire;
    } else if (values.mail && values.mail && !isEmail(values.mail)) {
      errors.mail = ErreursConstante.formulaire.generale.emailIncorrect;
    }
    if (!values.listAdb) {
      errors.listAdb = ErreursConstante.formulaire.generale.champObligatoire;
    }
    if (!values.adbs) {
      errors.adbs = ErreursConstante.formulaire.generale.champObligatoire;
    } else if (values.adbs && values.adbs.length > 0) {
      const adbsErrors = [] as any[];
      values.adbs.forEach((adb, index) => {
        const adbError = {} as any;
        if (!adb.profil) {
          adbError.profil =
            ErreursConstante.formulaire.generale.champObligatoire;
        }
        if (!adb.sites || !adb.sites.length) {
          adbError.sites =
            ErreursConstante.formulaire.generale.champObligatoire;
        }
        adbsErrors[index] = adbError;
      });
      if (adbsErrors.length) {
        errors.adbs = adbsErrors;
      }
    }

    if ((!values.motDePasse || !isMotDePasse(values.motDePasse)) && !isModify) {
      errors.motDePasse = ErreursConstante.formulaire.generale.motPasse;
    }

    if (values.motDePasse !== values.confirmationMotDePasse && !isModify) {
      errors.confirmationMotDePasse =
        ErreursConstante.formulaire.generale.confirmationMotPasse;
    }
  }
  return errors;
};

export default UtilisateurAdbForm;
